import { useEffect, useState } from "react";

/** Speech bubble showing what the voice DJ is saying (Spotify shows the
 *  DJ's line on screen too — handy with the sound low). */
export function DjCaption() {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    let t: number | undefined;
    const on = (e: Event) => {
      const line = (e as CustomEvent<string>).detail;
      setText(line);
      window.clearTimeout(t);
      t = window.setTimeout(() => setText(null), Math.max(5000, line.length * 75));
    };
    window.addEventListener("dj-line", on);
    return () => { window.removeEventListener("dj-line", on); window.clearTimeout(t); };
  }, []);

  if (!text) return null;
  return (
    <div className="dj-caption" role="status" onClick={() => setText(null)}>
      <span className="dj-caption-badge">DJ</span>
      <span>{text}</span>
    </div>
  );
}
